<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="handleNavigateBack()">
  </ya-subheader>
  <div class="ya-page-content ya-page-content--inset ya-page-content--webshop">
    <div class="coupon-info">
      <div class="content-description">
        <h3 langkey="phCoupon_Redeem_Title"></h3>
        <span langkey="phCoupon_Redeem_Description"></span>
      </div>
    </div>
    <!--#app coupons-->
    <ng-container *ngIf="isMobile && isAppCouponActive">
      <ng-container *ngIf="appCoupons$ | async; let appCoupons">
        <ng-container *ngIf="appCoupons.length>0">
          <div class="app-coupon-content content-background--mix" [class.swiperLess]="appCoupons.length <=2">
            <div class="content-description app-coupon_description">
              <h3 langkey="phCoupon_Redeem_AppCoupon_Title"></h3>
              <div class="app-coupon_forward" (click)="loadappCoupons()">
                <span langkey="phCoupon_Redeem_Show_All"></span>
                <div class="coupon-item__forwardicon">
                  <div class="inline-icon forward-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                </div>
              </div>
            </div>
            <div class="slick-slider">
              <swiper class="swiper-container" [config]="appCouponSliderconfig(appCoupons.length)" #swiperCoupons
                (init)="resizeSwiper(swiperCoupons)" (sliderMove)="sliderMoved=true">
                <ng-container *ngFor="let appCoupon of appCoupons">
                  <div class="coupon-items"
                    [class.coupon-item--disabled]="appCoupon.isRedeemed || isAppCouponInCart(appCoupon.id)"
                    (click)="openAppCouponProduct(appCoupon)">
                    <ng-container *ngIf="!appCoupon.anonymCode">
                      <div class="member-icon">
                        <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                        </div>
                      </div>
                    </ng-container>
                    <div class="img">
                      <div class="aspect-ratio-box menugroup-item__img">
                        <div class="aspect-ratio-box-inside">
                          <div class="aspect-ration-img-box">
                            <ng-container *ngIf="appCoupon.hasImage">
                              <img class="ya_image" [src]="appCoupon.image" alt="" />
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="appCoupon.isRedeemed">
                      <div class="coupon-state coupon-state--redeemed" data-testid="coupon-state-redeemed">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-done"></div>
                        <span langkey="phCoupon_State_AlreadyRedeemed"></span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!appCoupon.isRedeemed && isAppCouponInCart(appCoupon.id)">
                      <div class="coupon-state coupon-state--in-cart" data-testid="coupon-state-in-cart">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
                        <span langkey="phCoupon_State_InCart"></span>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </swiper>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <!-- #Scan -->
    <ng-container *ngIf="useScan">
      <div class="qrcode-content content-background--mix">
        <div class="inline-icon qrcode_icon" inlineSVG="shop-icons.svg#ya-hypersoft-qr"></div>
        <div class="content-description">
          <h3 langkey="phCoupon_Redeem_Scan_Title"> </h3>
        </div>
        <div class="ya-webshop-button-container coupon-btn--continue">
          <button mat-flat-button (click)="NavigateToScanCoupon()">
            <span langkey="phCoupon_Redeem_Scan_Btn_Text"></span>
          </button>
        </div>
      </div>
    </ng-container>
    <!-- #input-->
    <div class="coupon-code__input-content content-background--mix ">
      <div class="inline-icon coupon_icon" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
      <div class="content-description">
        <h3 langkey="phCoupon_Redeem_Input_Title"></h3>
      </div>
      <div class="content-container_input">
        <div class="coupon-input coupon-input_wrapper">
          <div class="ya-input-wrapper ">
            <input a11y_Input class="ya-input-text" [placeholder]="placeholder" [formControl]="inputFormControl"
              (blur)="setWebView()">
            <ng-container *ngIf="inputFormControl.touched && inputFormControl.invalid">
              <ng-container *ngIf="inputFormControl.errors">
                <ng-container *ngIf="inputFormControl.errors.minLengthError">
                  <ya-errorvalidation [controlValidation]="inputFormControl.errors.minLengthError"
                    [errorMessage]="CouponRedeemErrorMinLength"></ya-errorvalidation>
                </ng-container>
                <ng-container *ngIf="inputFormControl.errors.maxLengthError">
                  <ya-errorvalidation [controlValidation]="inputFormControl.errors.maxLengthError"
                    [errorMessage]="CouponRedeemErrorMaxLength"></ya-errorvalidation>
                </ng-container>
                <ng-container *ngIf="inputFormControl.errors.pattern">
                  <ya-errorvalidation [controlValidation]="inputFormControl.errors.pattern"
                    errorMessage="phCoupon_Redeem_Error_NumbersOnly"></ya-errorvalidation>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="ya-webshop-button-container coupon-btn--continue">
        <button a11y_Button mat-flat-button [disabled]="inputFormControl.value==='' ||!inputFormControl.valid"
          (click)="OpenCouponProductByEnteringCode()">
          <span langkey="phGlobal_Continue"></span>
        </button>
      </div>
    </div>
  </div>
</div>